import React from 'react';
import { Paper, Stack, Group, Button } from '@mantine/core';
import BillingSettingsTable from '../components/table/BillingSettingsTable.tsx';
import { useNavigate } from 'react-router-dom';
import useParkingBillingSettings from '../hooks/useParkingBillingSettings.ts';
import { useBillingFilter } from '../hooks/useBillingFilter.tsx';
import { uniqueByKeys } from '../utils/array.ts';
import SiteProviderFilter from '../components/filter/SiteProviderFilter.tsx';
import sortBy from 'lodash.sortby';

export default function BillingSettingsListPage() {
  const navigate = useNavigate();

  const { isLoading: isScheduleTaskLoading, data: billingSettings = [] } =
    useParkingBillingSettings();
  const { filteredData, handleFilter } = useBillingFilter(billingSettings);

  const handleEdit = (id: string) => {
    navigate(`/billing/settings/${id}`);
  };

  const siteProviders = uniqueByKeys(
    billingSettings.map((x) => x.siteProvider),
    ['id'],
  );

  return (
    <Paper p="xl" radius="lg" shadow="xl" mb="xl">
      <Stack gap="xl">
        <SiteProviderFilter providers={siteProviders} onFilter={handleFilter} />
        <Group justify="flex-end">
          <Button onClick={() => navigate('/billing/settings/new')}>
            新增
          </Button>
        </Group>
        <BillingSettingsTable
          data={sortBy(filteredData, 'createdAt').reverse()}
          isLoading={isScheduleTaskLoading}
          onEdit={handleEdit}
        />
      </Stack>
    </Paper>
  );
}
